import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavLink',
    props: {
        href: {},
        active: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const classes = computed(() => props.active
            ? 'inline-flex items-center px-1 pt-1 border-b-2 border-indigo-400 text-sm font-medium leading-5 text-gray-900 focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out'
            : 'inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out');
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Link), {
                href: __props.href,
                class: _normalizeClass(classes.value)
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 8, ["href", "class"]));
        };
    }
});
